import React from "react";
import Screenshot from "../imgs/facle.png";

export const Facle = () => {
  return (
    <div className="itemContainer">
      <div className="itemContained">
        <img
          src={Screenshot}
          alt="Facle"
          className="screenshot"

        />
      </div>
      <div
        className="itemContained itemExplainer"

      >
        <center>
          <span className="itemTitle">Facle</span>
          <br />
          <br />

          <span className="itemBody">
            A Gaelic version of the hit word-game Wordle
          </span>
        </center>
      </div>
    </div>
  );
};
